import LowerCode from './LowerCode/index'
import Preview from './Preview/index'

const coms = [LowerCode, Preview]

const install = function (Vue) {
    coms.forEach(com => {
        console.log('组件目录', com)
        Vue.component(com.name, com)
    })
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}

export default { install, LowerCode, Preview }
